import Base from "./base";

class PaymentOrdersResource extends Base {
  path = "/v2/admin/payments/orders";

  getAll = async (query) => {
    const res = await this.getRequest(this.path, query);
    return {
      data: res?.data || [],
      total: res?.total ?? 0,
    };
  };

  getPendingCount = () =>
    this.getRequest("/v2/admin/payments/orders/pending-count");

  confirm = (publicId, data = {}) =>
    this.postRequest(`${this.path}/${publicId}/confirm`, data);

  update = (publicId, data = {}) =>
    this.putRequest(`${this.path}/${publicId}`, data);

  delete = (publicId) => this.deleteRequest(`${this.path}/${publicId}`);
}

export default new PaymentOrdersResource();
